module.exports = __webpack_public_path__ + "static/media/winner-frame.e6fbbcd8.svg";